import { FC } from "react"

import ModalHeader from "./ModalHeader"
import ModalFooter from "./ModalFooter"
import ModalBody from "./ModalBody"
import useKeyboard from "../../hooks/useKeyboard"
import { keyCodes } from "../../common/keyCodes"

interface IProps {
  ctaText: string
  cancelText?: string
  isOpen: boolean
  title: string
  showCancel?: boolean
  onToggle?: () => void
  onClose?: (e: any) => void
  onCallback?: (e: void) => void
  size?: "sm" | "lg" | "auto"
  overflow?: boolean
  position?: "top" | "bottom"
  fixedHeight?: string
  fixedWidth?: string
  autoFocus?: boolean
}

const CustomModal: FC<IProps> = ({
  //#region props
  children,
  isOpen,
  onToggle,
  onCallback,
  onClose,
  title,
  ctaText,
  cancelText,
  overflow,
  size,
  position,
  fixedHeight,
  fixedWidth,
  showCancel

  //#endregion
}) => {
  useKeyboard(() => onToggle(), [keyCodes.esc])

  return (
    isOpen && (
      <div
        className={`ocs-overlay ${overflow ? "overflow" : ""} ${
          position ? position : ""
        } `}
        onClick={onClose}
      >
        <article
          className={`ocs-modal custom-modal ${size ? size : ""}`}
          style={{
            height: fixedHeight ?? "unset",
            width: fixedWidth ?? "unset"
          }}
        >
          <ModalHeader title={title} onClick={onToggle} />
          <ModalBody>{children}</ModalBody>

          <ModalFooter
            ctaText={ctaText}
            cancelText={cancelText}
            onCallback={onCallback}
            onToggle={onToggle}
            hideCancel={!showCancel}
          />
        </article>
      </div>
    )
  )
}

export default CustomModal
